import React from 'react';
import { Logo } from './Logo';
import { Button } from './Button';
import { navLinks } from '../data/content';
import type { LandingActions } from '../types/actions';
export function Header({
  onFormCta
}: Pick<LandingActions, 'onFormCta'>) {
  return <header className="sticky top-0 z-40 w-full border-b border-line bg-white/90 backdrop-blur-md" data-id="element-117" data-mp="2ik62z6fbq6e6">
      <div className="mx-auto flex h-14 max-w-content items-center justify-between px-4 md:h-[68px] md:px-8" data-id="element-118" data-mp="2nih9p8abo0s6">
        <a href="#top" className="flex items-center" aria-label="HomeSmart NEXT home" data-id="element-119" data-mp="2rkb797p80oo4">
          <Logo data-id="element-120" data-mp="2wj5po8ja0b7p" />
        </a>

        <nav aria-label="Primary" className="hidden items-center gap-8 lg:flex" data-id="element-121" data-mp="31c8lknbizwr2">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-[15px] font-medium text-ink-600 transition-colors duration-150 ease-smooth hover:text-ink" data-id="element-122" data-mp="36bbgvg1peolu">
              {link.label}
            </a>)}
        </nav>

        <Button size="md" onClick={() => onFormCta('header')} className="hidden sm:inline-flex" data-id="element-123" data-mp="2wkkyrd1czo3r">
          Start a Private Conversation
        </Button>
        <Button size="md" onClick={() => onFormCta('header_mobile')} className="sm:hidden" data-id="element-124" data-mp="2rk6qbtvuic57">
          Get Started
        </Button>
      </div>
    </header>;
}